import { createSlice } from '@reduxjs/toolkit';
import {
   announcementListing,
   announcementDetail,
   exportAnnouncementToPdf,
   exportAnnouncementToXml,
   importAnnouncementData
}  from '../actions/announcement';

export const announcementSlice = createSlice({
    name: 'announcement',
    initialState: {
        loading: false,
        importLoading: false,
        listing: [],
        detail: [],
        import: [],
        pdfExport: null, // null = not start, true = successfully, false = unsuccessfully
        pdfError: null, // null = without error, or string with error
        xmlExport: null, // null = not start, true = successfully, false = unsuccessfully
        xmlError: null, // null = without error, or string with error
        importError: null
    },
    reducers: {

    },
    extraReducers:(builder) => {
        builder
            // LISTING
            .addCase(announcementListing.pending,(state) => { state.loading = true })
            .addCase(announcementListing.fulfilled,(state, action) => { 
                state.loading = false;
                state.listing = action.payload;
            })
            .addCase(announcementListing.rejected, (state) => { state.loading = false  })
            // DETAIL
            .addCase(announcementDetail.pending,(state) => { state.loading = true })
            .addCase(announcementDetail.fulfilled,(state, action) => {
                state.loading = false;
                state.detail = action.payload;
            })
            .addCase(announcementDetail.rejected, (state) => { state.loading = false  })
            // EXPORT TO PDF
            .addCase(exportAnnouncementToPdf.pending,(state) => { 
                state.pdfExport = null; // Reset state
                state.pdfError = null; // Reset error 
            })
            .addCase(exportAnnouncementToPdf.fulfilled,(state) => {
                state.pdfExport = true; // Operation successfully
                state.pdfError = null; // Without error
            })
            .addCase(exportAnnouncementToPdf.rejected, (state, action) => { 
                state.pdfExport = false; // Operation unsuccessfully
                state.pdfError = action.error.message || "Unknown error."; // Save error message
            })
             // EXPORT TO XML
             .addCase(exportAnnouncementToXml.pending,(state) => { 
                state.xmlExport = null; // Reset state
                state.xmlError = null; // Reset error 
            })
            .addCase(exportAnnouncementToXml.fulfilled,(state) => {
                state.xmlExport = true; // Operation successfully
                state.xmlError = null; // Without error
            })
            .addCase(exportAnnouncementToXml.rejected, (state, action) => { 
                state.xmlExport = false; // Operation unsuccessfully
                state.xmlError = action.error.message || "Unknown error."; // Save error message
            })
            // IMPORT DATA
            .addCase(importAnnouncementData.pending, (state) => { 
                state.importLoading = true;  // Nastav loading pri importe
                state.importError = null;   // Reset error pri importe
            })
            .addCase(importAnnouncementData.fulfilled, (state, action) => {
                state.importLoading = false;  // Reset loading po úspešnom importe
                state.import = action.payload;  // Uloženie importovaných dát
            })
            .addCase(importAnnouncementData.rejected, (state, action) => { 
                state.importLoading = false;  // Reset loading pri neúspešnom importe
                state.importError = action.error.message || "Unknown error.";  // Nastavenie chybovej správy
            });
    }
});

export default announcementSlice.reducer; 
